/**
 * Firebase RTDB のキーとして禁止されている文字をエスケープします。
 * 対象: . $ [ ] # /
 */
export const escapeKey = (name) => {
  return name.replace(/[\.\$\[\]\#\/]/g, (char) => {
    return '%' + char.charCodeAt(0).toString(16).toUpperCase();
  });
};

/**
 * エスケープされたキーを元の文字列に戻します。
 */
export const unescapeKey = (escapedName) => {
  return escapedName.replace(/%([0-9A-F]{2})/g, (_, hex) => {
    return String.fromCharCode(parseInt(hex, 16));
  });
};